import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { Component } from '../../types/builder';
import { useBuilderStore } from '../../store/builderStore';
import { ComponentRenderer } from './ComponentRenderer';

interface SortableComponentProps {
  component: Component;
}

export const SortableComponent: React.FC<SortableComponentProps> = ({ component }) => {
  const { selectComponent, selectedComponent, isPreviewMode } = useBuilderStore();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: component.id, disabled: isPreviewMode });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const isSelected = selectedComponent?.id === component.id;

  const handleClick = () => {
    if (!isPreviewMode) {
      console.log('Selecting component:', component.id);
      selectComponent(component);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onMouseDown={(e) => {
        // Only select on left click, not when dragging
        if (e.button === 0 && !isPreviewMode) {
          handleClick();
        }
      }}
      className={`relative ${
        isSelected && !isPreviewMode ? 'ring-2 ring-blue-500 ring-offset-2' : ''
      } ${!isPreviewMode ? 'cursor-move' : ''}`}
    >
      <ComponentRenderer component={component} />
    </div>
  );
};

